import * as React from "react";
import { Note } from "../../../types/Note";
import Button from "../../Button/Button";
import "./NotesInner.css";
import Collapse from "@material-ui/core/Collapse";
import NoteComponent from "./Note/Note";
import LockIcon from "@material-ui/icons/Lock";
import DiscriptionIcon from "@material-ui/icons/DescriptionOutlined";
import Input from "../../Input/Input";
import CommentIcon from "@material-ui/icons/Comment";

interface Props {
	notes: Note[];
	isLoading?: boolean;
	addNote: (text: string) => void;
	onEdit: (noteId: number, note: string) => Promise<boolean>;
	onDelete: (nodeId: number) => Promise<boolean>;
}

const NotesInner: React.FunctionComponent<Props> = (props) => {
	const [buttonsVisible, setButtonsVisible] = React.useState(false);

	const textField = React.useRef<HTMLInputElement>(null);

	const textListener = (e: any) => {
		if (e.target.value.length >= 1) {
			setButtonsVisible(true);
		} else {
			setButtonsVisible(false);
		}
	};

	const addNote = () => {
		props.addNote(textField.current.value);
		setButtonsVisible(false);

		textField.current.value = "";
	};

	return (
		<div className="notes">
			<div className="notes__headerWrapper">
				<div className="notes__header">
					<CommentIcon /> Заметки к книге
				</div>

				<div className="notes__notice">
					<LockIcon />
					Заметки видны только вам
				</div>
			</div>

			<div className="notes__inner">
				<div className="notes__list">
					{props.notes.length === 0 && (
						<div className="notes__empty">
							<DiscriptionIcon />

							<div>К этой книге вы пока не оставляли заметки</div>
						</div>
					)}

					{props.notes.map((note) => {
						return (
							<NoteComponent
								note={note}
								key={note.id}
								onEdit={props.onEdit}
								onDelete={props.onDelete}
							/>
						);
					})}
				</div>

				<div className="notes__newField">
					<Input
						hiddenLabel={true}
						multiline={true}
						onChange={textListener}
						onBlur={() => {
							setButtonsVisible(false);
						}}
						onFocus={() => {
							setButtonsVisible(true);
						}}
						inputProps={{ ref: textField }}
						placeholder="Добавить заметку к книге"
						classes={{
							root: "notes__input"
						}}
					/>

					<div className="notes__newField__buttons">
						<Collapse in={buttonsVisible}>
							<Button
								onClick={addNote}
								isLoading={props.isLoading}
								type="primary"
							>
								Добавить
							</Button>
						</Collapse>
					</div>
				</div>
			</div>
		</div>
	);
};

export default NotesInner;
